import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import SixDigitCodeInput from '~/components/auth/SixDigitCodeInput'
import WinItButton from '~/components/WinItButton'
import Spacer from '~/components/Spacer'

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`

@inject((all) => ({
  auth: all.store.auth,
  loginCode: all.store.auth.loginCode,
  isAttemptingLogIn: all.store.auth.isAttemptingLogIn,
}))
@observer
class LoginCodeForm extends Component {
  handleCodeChange = (value) => {
    this.props.auth.changeKey('loginCode', value)
  }

  handleSubmit = (event) => {
    if (event?.preventDefault) event.preventDefault()
    this.props.auth.loginWithCode()
  }

  render() {
    const { auth, loginCode, isAttemptingLogIn } = this.props
    const loginCodeError = auth.validateDisplayMessage('loginCode')

    return (
      <FormContainer onSubmit={this.handleSubmit}>
        <SixDigitCodeInput
          value={loginCode}
          onChange={this.handleCodeChange}
          disabled={isAttemptingLogIn}
          error={loginCodeError}
        />
        <Spacer mobile={15} desktop={15} />
        <WinItButton
          onClick={this.handleSubmit}
          disabled={isAttemptingLogIn}
          type="submit"
        >
          {isAttemptingLogIn ? 'Signing in...' : 'Sign In with Code'}
        </WinItButton>
      </FormContainer>
    )
  }
}

export default LoginCodeForm
